// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2_5ic","title":"Images45_title__TU-WS","images":"Images45_images__2hvUz"};